// @tiptap/markdown drops HTML comments and turns any block with a tag outside its
// allowlist (SVG <text> is one) into entity-escaped literal text. Folding a chart
// block (see ArticleChart) into one attribute keeps it opaque to that parser.

const CHART_BLOCK_PATTERN = /<!-- chart:([a-z0-9-]+) -->[\s\S]*?<!-- \/chart:\1 -->/g;

export const HTML_BLOCK_ATTRIBUTE = "data-html-block";

export function encodeHtmlBlockAttribute(html) {
	return html.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/\r/g, "&#13;").replace(/\n/g, "&#10;");
}

export function protectHtmlBlocks(markdown) {
	return markdown.replace(CHART_BLOCK_PATTERN, (block) => `<div ${HTML_BLOCK_ATTRIBUTE}="${encodeHtmlBlockAttribute(block)}"></div>`);
}
